import {
  beautify,
  NoWrap,
  numberFormat,
  returnObject,
} from "../../../../utils/helpers";
type TAdhocProps = {
  dateFilterKey?: string;
  status?: string;
  noWrapColumns?: string[];
  numberColumns?: string[];
};
const useAdhocReport = ({
  dateFilterKey,
  noWrapColumns = [],
  numberColumns = [],
}: TAdhocProps) => {
  const tableColumns = (data: any) => {
    const firstItem = data[0] || {};
    const filterColumns = [
      {
        id: dateFilterKey || "created_at",
        header: beautify(dateFilterKey || "Created At"),
        filter: { type: "date_select" },
      },
    ];
    const columns = Object.keys(firstItem).map((column: any) => ({
      id: column,
      header: <NoWrap>{beautify(column)}</NoWrap>,
      filter: true,
    }));
    return [...filterColumns, ...columns];
  };

  const tableData = (data: any) => {
    return data.map((item: any) => ({
      ...item,
      [dateFilterKey || "created_at"]: (
        <NoWrap>{item[dateFilterKey || "created_at"]}</NoWrap>
      ),
      id: <NoWrap>{item.id}</NoWrap>,
      ...returnObject(
        noWrapColumns.length > 0,
        noWrapColumns.reduce((obj, column) => {
          if (item[column] !== undefined) {
            obj[column] = <NoWrap>{item[column]}</NoWrap>;
          }
          return obj;
        }, {}),
      ),
      ...returnObject(
        numberColumns.length > 0,
        numberColumns.reduce((obj, column) => {
          if (item[column] !== undefined) {
            obj[column] = numberFormat(item[column]);
          }
          return obj;
        }, {}),
      ),
    }));
  };
  const today = new Date();
  const initialFilters = {
    [`${dateFilterKey || "created_at"}_max_date`]: today,
    [`${dateFilterKey || "created_at"}_min_date`]: today,
    stringValue: `${today.toLocaleDateString()} - ${today.toLocaleDateString()}`,
  };

  return { tableColumns, tableData, initialFilters };
};

export default useAdhocReport;

export const useLedgerReport = () => {
  const numberColumns = ["amount"];
  const noWrapColumns = ["reference_number", "credit_account_name"];

  const { tableColumns, tableData, initialFilters } = useAdhocReport({
    dateFilterKey: "transaction_date",
    numberColumns,
    noWrapColumns,
  });

  return { tableColumns, tableData, initialFilters };
};
